// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChatWindow.css */
.chat-window {
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Table styles for markdown content */
.markdown-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 1rem 0;
  background-color: var(--table-background-color);
  border: 1px solid var(--table-border-color);
}
 
.markdown-content thead {
  background-color: var(--table-header-bg-color);
}
 
.markdown-content th {
  padding: 0.75rem;
  border: 1px solid var(--table-border-color);
  font-weight: 600;
  text-align: left;
}
 
.markdown-content td {
  padding: 0.75rem;
  border: 1px solid var(--table-border-color);
}
 
.markdown-content tr:nth-child(even) {
  background-color: var(--table-row-alt-bg);
}
 
.markdown-content tr:hover {
  background-color: var(--table-hover-bg);
}
 
.user-message {
  align-self: flex-end;
  background-color: var(--user-message-background);
  color: var(--text-color);
  border-radius: 18px;
  padding: 0px 15px;
  margin-bottom: 10px;
  max-width: 75%;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 14px;
  overflow-wrap: break-word;
  word-break: break-word;
}
 
.assistant-message-container {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  width: 95%;
}
 
.assistant-icon {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
 
.assistant-text {
  color: var(--text-color);
  max-width: 100%;
  padding: 10px;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  width: 100%;
}
 
.file-upload-bubble {
  display: flex;
  align-items: center;
  background-color: var(--user-message-background);
  color: var(--text-color);
  padding: 8px 10px;
  border-radius: 12px;
  max-width: 250px;
  margin-bottom: 10px;
  overflow: hidden;
}
 
.file-icon {
  font-size: 18px;
  color: #4a90e2;
  margin-right: 8px;
}
 
.file-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
 
.loading-indicator {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 0;
  padding: 0;
  background-color: transparent;
  font-family: 'Inter', Arial, sans-serif;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.5;
}
 
/* Subtle fade-in and fade-out animation for the text */
.loading-indicator .text {
  color: gray;
  animation: fadeInOut 2s infinite;
}
 
/* Subtle fade-in and fade-out animation for emojis */
.loading-indicator .emoji {
  margin-left: 5px;
  animation: fadeInOut 2s infinite;
}
 
/* Define subtle fade-in and fade-out animation */
@keyframes fadeInOut {
  0% { opacity: 0.5; }
  50% { opacity: 1; }
  100% { opacity: 0.5; }
}
 
/* Hide scrollbar */
/* .chat-window::-webkit-scrollbar {
  display: none;
}
.chat-window {
  scrollbar-width: none;
  -ms-overflow-style: none;
} */
 
/* Table wrapper */
.table-wrapper {
  border: 1px solid var(--table-border-color);
  padding: 25px 10px 10px 10px;
  margin-bottom: 10px;
  background: var(--table-background-color);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  position: relative;
  max-width: 90%;
  width: auto;
  overflow-x: auto;
  display: block;
}
 
/* Table content */
/* .table-content {
  padding: 0px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: auto;
  white-space: normal;
} */

.table-content {
  padding: 0px;
  white-space: normal;
  overflow: unset;
  max-height: none;
}

.table-wrapper:not(.full-screen) .table-actions {
  position: absolute;
  top: 4px;
  right: 10px; /* 👈 push it to the right */
  z-index: 10;
}

.markdown-content {
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  display: block;
}
 
/* Full-Screen Mode */
/* Full-Screen Mode - Ensure Full Table is Visible */
.full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: var(--background-color);
  z-index: 1000;
  padding: 20px;
  overflow: auto; /* Allow scrolling only when necessary */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 97%;
  align-items: center;   /* 👈 push to left */
  justify-content: center; /* 👈 push to top */
  padding: 40px;              /* Optional: space from edges */
}
 
.full-screen .table-wrapper {
  width: 100%;
  max-width: 100%;
  height: 100%; /* 👈 Fill the full height of the screen */
  max-height: 100%;
  height: auto;
}


.full-screen .table-content {
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  padding-bottom: 40px;
  box-sizing: border-box;
}

 
/* Close Full-Screen Button */
.close-fullscreen-btn {
  position: absolute;
  top: 15px;
  right: 40px;
  background: #838282;
  color: white;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  z-index: 1100;
}
 
.close-fullscreen-btn:hover {
  background: #3d3838;
}
 
/* Ensuring the icons align properly */
/* Ensuring the icons align properly to the right */
/* Ensuring the icons align properly to the right */
/* .table-actions {
  display: flex;
  align-items: center;
  gap: 8px; 
  justify-content: flex-end; 
  width: 100%;
}

.full-screen .table-actions {
  position: relative;
  justify-content: center;
  width: 100%;
  right: auto;
  top: auto;
  margin-top: 15px;
}
  
*/

/* Normal mode - right aligned */
.table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
}

/* Full-screen mode - centered */
.full-screen .table-actions {
  display: flex;
  justify-content: center;
  position: static;
  margin: 15px auto 20px;
  width: 100%;
  transform: none;
}

/* Table Action Icons */
.download-icon, .expand-icon {
  cursor: pointer;
  font-size: 18px;
  color: var(--table-accent-color);
  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;
}
 
/* Ensure buttons stay in correct order */
.download-icon {
  order: 0; /* Appears first */
}
 
.expand-icon {
  order: 1; /* Appears second */
}
 
.download-icon:hover, .expand-icon:hover {
  color: #0056b3;
  transform: scale(1.1);
}
 
/* Chat Window Layout */
.chat-window-container {
  display: flex;
  height: calc(100vh - 60px); /* Below Header */
  width: 100%;
  overflow: hidden;
}
/* Chat Container */
.chat-container {
  display: flex;
  height: calc(100vh - 60px);
  width: 100%;
  position: relative;
}
 
/* Left Edge Detection for Hover */
.hover-detect-area {
  position: fixed;
  left: 0;
  top: 72px;
  width: 10px; /* Very thin area to detect hover */
  height: calc(100vh - 72px);
  z-index: 1000;
}
 
/* Sidebar - Default Hidden */
.sidebar {
  width: 260px;
  background: var(--background-color);
  padding: 15px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--hover-background-color);
  position: fixed;
  left: -260px; /* Hides the sidebar */
  top: 72px;
  bottom: 0;
  height: calc(100vh - 72px);
  transition: left 0.3s ease-in-out;
  overflow-y: auto;
 
}
.sidebar::-webkit-scrollbar {
  width: 6px;
}
 
.sidebar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
/* Show Sidebar on Hover */
.sidebar.visible {
  left: 0;
}
 
/* Sidebar When Pinned */
.sidebar.pinned {
  left: 0;
}
 
/* Sidebar Header */
.sidebar-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
 
/* Pin Button */
.pin-button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: var(--button-color);
  transition: color 0.2s ease-in-out;
}
.pin-icon {
  transition: transform 0.2s ease-in-out;
}
 
/* Highlight When Pinned */
.pinned-icon {
  color: #007bff !important; /* Blue color for pinned state */
}
 
/* Ensure Chat Window Doesn't Move */
.chat-window {
  flex-grow: 1;
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
 
 
.start-new-chat {
  background: #4a90e2; /* Bright Blue */
  color: white;
  border: none;
  padding: 8px 14px; /* Reduced padding to make the button shorter */
  border-radius: 6px; /* Slightly smaller radius */
  font-size: 14px; /* Reduced font size */
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
 
/* Hover Effect */
.start-new-chat:hover {
  background: #0056b3; /* Darker Blue */
  transform: scale(1.05);
}
 
/* Click Effect */
.start-new-chat:active {
  background: #004494;
  transform: scale(0.98);
}
 
 
/* Recent Chats */
.recent-chats {
  margin-top: 10px;
}
 
.recent-title {
  font-size: 14px;
  font-weight: bold;
  color: var(--text-color);
  margin-bottom: 8px;
}
 
 
 
/* Chat List Styling */
.chat-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
 
/* Individual Chat Item */
.chat-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: transparent;
  border-radius: 6px;
  font-size: 14px;
  color: var(--text-color);
  cursor: pointer;
  transition: background 0.3s ease-in-out;
  position: relative;
}
 
/* Highlight Active Session */
.chat-item.active-session {
  background-color: rgba(135, 191, 255, 0.3); /* Light blue */
  color: #007bff; /* Blue text */
  font-weight: 600;
  border-left: 4px solid #007bff;
  transition: all 0.3s ease-in-out;
}
 
/* Hover Effect */
.chat-item:hover {
  background-color: rgba(135, 191, 255, 0.5);
}
 
/* Three Dots Button */
.menu-button {
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: var(--text-color);
  transition: color 0.2s ease-in-out;
}
 
/* Dropdown Menu (Light/Dark Mode Adaptive) */
.menu-dropdown {
  position: absolute;
  right: 10px;
  top: 100%;
  background: var(--menu-background); /* Uses theme variable */
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
  width: 140px;
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  z-index: 100;
  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;
}
 
/* Dropdown Items */
.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 500;
  color: var(--menu-text-color); /* Adaptive text color */
  background: transparent;
  border: none;
  width: 100%;
  text-align: left;
  transition: background 0.2s ease-in-out;
}
 
/* Hover Effect on Menu Items */
.menu-item:hover {
  background: var(--menu-hover-bg);
}
 
/* Delete Button Styling */
.menu-item.delete {
  color: #ff4d4d; /* Red for delete */
}
 
.menu-item.delete:hover {
  background: rgba(255, 77, 77, 0.1);
}
 
/* Menu Icon Styling */
.menu-icon {
  font-size: 16px;
}
 
.disabled-session {
  pointer-events: none;  /* Prevent clicks */
  opacity: 0.5;         /* Dim the session visually */
  cursor: not-allowed;  /* Show a blocked cursor */
}
 
.start-new-chat.disabled-session {
  pointer-events: none;  /* Disable clicks */
  opacity: 0.5;         /* Dim the button */
  cursor: not-allowed;  /* Show blocked cursor */
}
 
/* Overlay for Popup */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}
 
/* Confirmation Popup */
.confirmation-popup {
  background: var(--background-color);
  color: var(--text-color);
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  min-width: 300px;
}
 
/* Popup Buttons */
.popup-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
 
/* Cancel Button */
.cancel-btn {
  background: var(--button-background);
  color: var(--text-color);
  border: 1px solid var(--border-color);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
 
.cancel-btn:hover {
  background: var(--hover-background);
}
 
/* Delete Button */
.delete-btn {
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}
 
.delete-btn:hover {
  background: #d43f3f;
}
 
 
/* Temporary Chat Toggle Button */
.temporary-chat-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 10px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
/* Bubble around the Temporary Button */
.temporary-chat-bubble {
  display: flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 50px;
  border: 1px solid var(--border-color);
  transition: background 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  gap: 6px; /* Added space between icon and text */
}
 
.temporary-chat-bubble:hover {
  background: var(--hover-background);
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}
 
/* Icon Styles */
.temporary-chat-icon {
  font-size: 18px;
  color: gray;
  transition: color 0.3s ease-in-out;
}
 
/* Active (Green) Icon */
.temporary-chat-icon.active {
  color: #1db954;
}
 
/* Light Mode - Black Text */
[data-theme='light'] .temporary-chat-label {
  color: #000;
}
 
/* Dark Mode - White Text */
[data-theme='dark'] .temporary-chat-label {
  color: #fff;
}

/* Reduced font size for Temporary Chat label */
.temporary-chat-label {
  font-size: 12px; /* Adjusted for smaller text */
}

.temporary-chat-banner {
  position: fixed;
  top: 75px; /* Adjust top spacing as needed */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  background: var(--banner-background);
  color: var(--banner-text);
  padding: 3px 12px;
  border-radius: 16px;
  font-weight: 500;
  font-size: 13px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);

  width: fit-content;
  max-width: 90%;
}
/* Info Icon */
.info-icon {
  font-size: 18px;
  cursor: pointer;
  color: var(--info-text);
  transition: color 0.3s ease-in-out;
}
 
.info-icon:hover {
  color: var(--info-hover-text);
}
 
 
 
/* --- New CSS for Recents Header and Delete All Menu --- */
.recents-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative; /* Needed for absolute positioning of dropdown */
  margin-bottom: 8px; /* Adjust as needed */
}
 
.recents-menu-button {
  background: transparent;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0 5px;
  line-height: 1;
  color: var(--text-color);
}
 
/* Dropdown container for the Recents menu */
.recents-menu-dropdown {
  position: absolute;
  top: 100%; /* Directly below the header */
  right: 0;
  background: var(--background-color); /* Use your theme variable or a fallback */
  border: 1px solid var(--border-color); /* Use your theme variable */
  min-width: 120px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 100;
  padding: 5px 0;
}
 
/* Dropdown menu items */
.recents-menu-dropdown .menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  text-align: left;
  color: var(--text-color);
  background: transparent;
  border: none;
  cursor: pointer;
}
 
.recents-menu-dropdown .menu-item:hover {
  background: var(--hover-background);
}
 
/* Special styling for the Delete All item */
.recents-menu-dropdown .delete-all {
  color: #d9534f; /* Danger color */
}


.summary-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6); /* Dark overlay */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

/* Make the content scrollable while keeping header and footer fixed */
.summary-popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 80%;
  max-width: 700px;
  max-height: 70vh; /* Restrict height */
  display: flex;
  flex-direction: column;
  text-align: left; /* Align content to the left */
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
}

/* Scrollable text container */
.summary-popup-body {
  flex-grow: 1;
  overflow-y: auto; /* Enable vertical scrolling */
  padding: 10px;
  text-align: left; /* Ensure text is left-aligned */
}

/* Ensure paragraphs, lists, and headings are also left-aligned */
.summary-popup-body p,
.summary-popup-body ul,
.summary-popup-body ol,
.summary-popup-body h2 {
  text-align: left;
}

/* Restore Blue Title Color */
.summary-popup-content h2 {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #007bff; /* Keep titles blue */
  position: sticky;
  top: 0;
  background: white;
  padding-bottom: 10px;
  z-index: 10;
}

/* Restore Blue for Bold Text */
.summary-popup-content strong {
  color: #007bff;
}

/* Sticky Footer (for Close button) */
.summary-popup-footer {
  text-align: center;
  padding-top: 10px;
  background: white;
  position: sticky;
  bottom: 0;
  padding-bottom: 10px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow effect */
}

/* Close Button */
.summary-close-btn {
  background: #ff4d4d;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  width: 100px;
}

.summary-close-btn:hover {
  background: #d43f3f;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #007bff;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
  margin-left: 8px; /* Add some space between the icon and the spinner */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Position Search Icon Next to Sidebar Toggle */
.search-button {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 10px;
}

.search-icon {
  font-size: 16px;
  color: #007BFF;
  transition: transform 0.2s ease-in-out, color 0.3s ease-in-out;
}

.search-icon:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.gradient-button {
  background: linear-gradient(to right, #1E90FF, #32CD32); /* Adjust colors */
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px; /* Space between text and icon */
  transition: 0.3s;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.gradient-button:hover {
  filter: brightness(1.1);
}

.graph-wrapper {
  position: relative;
  margin-bottom: 20px;
  max-width: 100%;
  overflow-x: auto;
  padding: 10px;
  background: var(--table-background-color);
  border: 1px solid var(--table-border-color);
  border-radius: 8px;
}

.graph-expand-button {
  position: absolute;
  top: 8px;
  right: 8px;
  background: #007bff;
  color: white;
  border: none;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  z-index: 10;
}

.graph-expand-button:hover {
  background: #0056b3;
}

.graph-fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  background: var(--background-color);
  padding: 20px;
  overflow: auto;
}

.graph-fullscreen .graph-expand-button {
  background: #d43f3f;
}

.graph-fullscreen .graph-expand-button:hover {
  background: #a92828;
}
/* Graph Plot Wrapper */
/* Graph Plot Wrapper */
.plot-wrapper {
  position: relative;
  border: 1px solid var(--table-border-color);
  background: var(--table-background-color);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 25px 10px 10px 10px;
  margin-bottom: 20px;
  overflow: hidden;
  max-width: 90%;
}

/* Non-fullscreen mode: actions container positioning */
.plot-wrapper:not(.full-screen) .plot-actions {
  position: absolute;
  top: 4px;
  right: 5px;
  z-index: 10;
  display: flex;
  gap: 8px;
}

/* Fullscreen mode: wrapper styling */
.full-screen.plot-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2000;
  padding: 20px;
  background: var(--background-color);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: auto;
  box-sizing: border-box;
  max-width: 100%;
}

/* Fullscreen mode: actions container positioning */
.full-screen .plot-actions {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  display: flex;
  gap: 8px;
}

/* Plot content area */
.plot-content {
  max-height: 400px;
  overflow: hidden;
  max-width: 100%;
}

/* Updated Expand/Compress Button Style for Graph (matching table style) */
.plot-actions button {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  color: var(--table-accent-color);
  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;
  display: flex;
  align-items: center;
}

.plot-actions button:hover {
  color: #0056b3;
  transform: scale(1.1);
}

.plot-actions button:focus {
  outline: none;
}

.full-screen .plot-content {
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: auto;
}

.chat-window {
  overflow-x: hidden !important; /* ✅ prevents horizontal scroll */
}


.assistant-text {
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal; /* ✅ important to prevent horizontal scroll */
}


.markdown-content {
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
} 

/* Make code blocks wrap instead of scroll */
.markdown-content pre code {
  display: block;
  overflow-x: auto;
  padding: 10px 16px;
  border-radius: 8px;
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: var(--code-bg);
  color: var(--code-text);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  transition: background 0.3s ease, color 0.3s ease;
}

.markdown-content pre {
  margin-top: 4px;     /* 🔽 Shrink from default (usually 16px) */
  margin-bottom: 4px;
}

/* ✅ Dark Mode Scrollbar Styling */
[data-theme='dark'] .chat-window::-webkit-scrollbar {
  width: 8px;
}

[data-theme='dark'] .chat-window::-webkit-scrollbar-track {
  background: #1e1e1e; /* Match your dark background */
}

[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb {
  background-color: #555;
  border-radius: 4px;
  border: 2px solid #1e1e1e; /* Creates padding around the thumb */
}

[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb:hover {
  background-color: #777;
}

/* Firefox (scrollbar styling) */
[data-theme='dark'] .chat-window {
  scrollbar-width: thin;
  scrollbar-color: #555 #1e1e1e;
}

/* ✅ Light Mode Scrollbar Styling */
[data-theme='light'] .chat-window::-webkit-scrollbar {
  width: 8px;
}

[data-theme='light'] .chat-window::-webkit-scrollbar-track {
  background: #f2f2f2; /* Light background */
}

[data-theme='light'] .chat-window::-webkit-scrollbar-thumb {
  background-color: #aaa;  /* Scroll thumb */
  border-radius: 4px;
  border: 2px solid #f2f2f2; /* Padding around thumb */
}

[data-theme='light'] .chat-window::-webkit-scrollbar-thumb:hover {
  background-color: #888;
}

/* Firefox (scrollbar styling) */
[data-theme='light'] .chat-window {
  scrollbar-width: thin;
  scrollbar-color: #aaa #f2f2f2;
}


.agent-status-message {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 16px;
  color: #444;
  gap: 6px;
  animation: fadeIn 0.3s ease-in;
}
 
.agent-status-message .emoji {
  animation: flicker 1.2s infinite;
}
 
.agent-status-message .dots {
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 1px;
  animation: bounce 1.2s infinite;
}
 
 
/* Emoji flicker */
@keyframes flicker {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.6; }
}
 
/* Optional fade-in when message appears */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to   { opacity: 1; transform: translateY(0); }
}


.dot-loader {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 24px;
}
.dot-loader span {
  width: 4px;
  height: 4px;
  background: #555;
  border-radius: 50%;
  display: inline-block;
  animation: dot-blink 1s infinite alternate;
}
.dot-loader span:nth-child(2) { animation-delay: .2s; }
.dot-loader span:nth-child(3) { animation-delay: .4s; }
@keyframes dot-blink {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}
 


.menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border: 1px solid #ccc;
  z-index: 999;
  transition: top 0.2s ease, bottom 0.2s ease;
}
 
.menu-dropdown.open-upward {
  top: auto;
  bottom: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/ChatWindow.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,+CAA+C;EAC/C,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;EAChD,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,wBAAwB;EACxB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,6BAA6B;EAC7B,uCAAuC;EACvC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,iDAAiD;AACjD;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,UAAU,EAAE;EAClB,OAAO,YAAY,EAAE;AACvB;;AAEA,mBAAmB;AACnB;;;;;;GAMG;;AAEH,kBAAkB;AAClB;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,mBAAmB;EACnB,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;;;;GAMG;;AAEH;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW,EAAE,4BAA4B;EACzC,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,qBAAqB;AACrB,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,cAAc,EAAE,wCAAwC;EACxD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB,IAAI,oBAAoB;EAC3C,uBAAuB,EAAE,mBAAmB;EAC5C,aAAa,eAAe,+BAA+B;AAC7D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY,EAAE,0CAA0C;EACxD,gBAAgB;EAChB,YAAY;AACd;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;;AAGA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC,mDAAmD;AACnD,mDAAmD;AACnD;;;;;;;;;;;;;;;;;CAiBC;;AAED,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,WAAW;AACb;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,8DAA8D;AAChE;;AAEA,yCAAyC;AACzC;EACE,QAAQ,EAAE,kBAAkB;AAC9B;;AAEA;EACE,QAAQ,EAAE,mBAAmB;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,0BAA0B,EAAE,iBAAiB;EAC7C,WAAW;EACX,gBAAgB;AAClB;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,WAAW,EAAE,mCAAmC;EAChD,0BAA0B;EAC1B,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,qDAAqD;EACrD,eAAe;EACf,YAAY,EAAE,sBAAsB;EACpC,SAAS;EACT,SAAS;EACT,0BAA0B;EAC1B,iCAAiC;EACjC,gBAAgB;;AAElB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;AACA,0BAA0B;AAC1B;EACE,OAAO;AACT;;AAEA,wBAAwB;AACxB;EACE,OAAO;AACT;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;AACpC;AACA;EACE,sCAAsC;AACxC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA,oCAAoC;AACpC;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;;AAGA;EACE,mBAAmB,EAAE,gBAAgB;EACrC,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE,+CAA+C;EAClE,kBAAkB,EAAE,4BAA4B;EAChD,eAAe,EAAE,sBAAsB;EACvC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,mBAAmB,EAAE,gBAAgB;EACrC,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA,iBAAiB;AACjB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;;;AAIA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,0CAA0C,EAAE,eAAe;EAC3D,cAAc,EAAE,cAAc;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kCAAkC,EAAE,wBAAwB;EAC5D,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,+DAA+D;AACjE;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B,EAAE,wBAAwB;EACvD,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,cAAc,EAAE,mBAAmB;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB,GAAG,mBAAmB;EAC1C,YAAY,UAAU,6BAA6B;EACnD,mBAAmB,GAAG,0BAA0B;AAClD;;AAEA;EACE,oBAAoB,GAAG,mBAAmB;EAC1C,YAAY,UAAU,mBAAmB;EACzC,mBAAmB,GAAG,wBAAwB;AAChD;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,oCAAoC;EACpC,wBAAwB;EACxB,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;AACA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,oEAAoE;EACpE,QAAQ,EAAE,sCAAsC;AAClD;;AAEA;EACE,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;EACX,kCAAkC;AACpC;;AAEA,wBAAwB;AACxB;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,eAAe,EAAE,8BAA8B;AACjD;;AAEA;EACE,eAAe;EACf,SAAS,EAAE,iCAAiC;EAC5C,SAAS;EACT,2BAA2B;EAC3B,aAAa;;EAEb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;EAER,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;;EAEzC,kBAAkB;EAClB,cAAc;AAChB;AACA,cAAc;AACd;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;;;AAIA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB,EAAE,gDAAgD;EACpE,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,SAAS,EAAE,8BAA8B;EACzC,QAAQ;EACR,mCAAmC,EAAE,0CAA0C;EAC/E,qCAAqC,EAAE,4BAA4B;EACnE,gBAAgB;EAChB,qCAAqC;EACrC,YAAY;EACZ,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4CAA4C;AAC5C;EACE,cAAc,EAAE,iBAAiB;AACnC;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B,EAAE,iBAAiB;EACjD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,sEAAsE;AACtE;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,gBAAgB,EAAE,oBAAoB;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAE,8BAA8B;EAChD,2CAA2C;AAC7C;;AAEA,8BAA8B;AAC9B;EACE,YAAY;EACZ,gBAAgB,EAAE,8BAA8B;EAChD,aAAa;EACb,gBAAgB,EAAE,gCAAgC;AACpD;;AAEA,iEAAiE;AACjE;;;;EAIE,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc,EAAE,qBAAqB;EACrC,gBAAgB;EAChB,MAAM;EACN,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,yCAAyC,EAAE,yBAAyB;AACtE;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gBAAgB,EAAE,oDAAoD;AACxE;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,8DAA8D;AAChE;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,uDAAuD,EAAE,kBAAkB;EAC3E,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ,EAAE,gCAAgC;EAC1C,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yCAAyC;EACzC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA,uBAAuB;AACvB,uBAAuB;AACvB;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,yCAAyC;EACzC,0CAA0C;EAC1C,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,8DAA8D;EAC9D,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B,EAAE,iCAAiC;AAClE;;;AAGA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB,EAAE,6CAA6C;AACpE;;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,8DAA8D;EAC9D,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;EAChC,uBAAuB;EACvB,yCAAyC;EACzC,iDAAiD;AACnD;;AAEA;EACE,eAAe,MAAM,0CAA0C;EAC/D,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB,EAAE,qCAAqC;AAClE;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,sBAAsB,GAAG,iBAAiB;EAC1C,kBAAkB;EAClB,yBAAyB,EAAE,yBAAyB;AACtD;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;AACjC;;;AAGA,kBAAkB;AAClB;EACE,WAAW,UAAU,EAAE;EACvB,WAAW,YAAY,EAAE;AAC3B;;AAEA,0CAA0C;AAC1C;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;;AAGA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,0CAA0C;AAC5C;AACA,gCAAgC,oBAAoB,EAAE;AACtD,gCAAgC,oBAAoB,EAAE;AACtD;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;;;AAIA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;EACvB,qCAAqC;EACrC,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,YAAY;AACd","sourcesContent":["/* ChatWindow.css */\r\n.chat-window {\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* Table styles for markdown content */\r\n.markdown-content table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin: 1rem 0;\r\n  background-color: var(--table-background-color);\r\n  border: 1px solid var(--table-border-color);\r\n}\r\n \r\n.markdown-content thead {\r\n  background-color: var(--table-header-bg-color);\r\n}\r\n \r\n.markdown-content th {\r\n  padding: 0.75rem;\r\n  border: 1px solid var(--table-border-color);\r\n  font-weight: 600;\r\n  text-align: left;\r\n}\r\n \r\n.markdown-content td {\r\n  padding: 0.75rem;\r\n  border: 1px solid var(--table-border-color);\r\n}\r\n \r\n.markdown-content tr:nth-child(even) {\r\n  background-color: var(--table-row-alt-bg);\r\n}\r\n \r\n.markdown-content tr:hover {\r\n  background-color: var(--table-hover-bg);\r\n}\r\n \r\n.user-message {\r\n  align-self: flex-end;\r\n  background-color: var(--user-message-background);\r\n  color: var(--text-color);\r\n  border-radius: 18px;\r\n  padding: 0px 15px;\r\n  margin-bottom: 10px;\r\n  max-width: 75%;\r\n  font-family: 'Inter', Arial, sans-serif;\r\n  font-size: 14px;\r\n  overflow-wrap: break-word;\r\n  word-break: break-word;\r\n}\r\n \r\n.assistant-message-container {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  margin-bottom: 10px;\r\n  width: 95%;\r\n}\r\n \r\n.assistant-icon {\r\n  width: 30px;\r\n  height: 30px;\r\n  margin-right: 10px;\r\n}\r\n \r\n.assistant-text {\r\n  color: var(--text-color);\r\n  max-width: 100%;\r\n  padding: 10px;\r\n  font-family: 'Inter', Arial, sans-serif;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  width: 100%;\r\n}\r\n \r\n.file-upload-bubble {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: var(--user-message-background);\r\n  color: var(--text-color);\r\n  padding: 8px 10px;\r\n  border-radius: 12px;\r\n  max-width: 250px;\r\n  margin-bottom: 10px;\r\n  overflow: hidden;\r\n}\r\n \r\n.file-icon {\r\n  font-size: 18px;\r\n  color: #4a90e2;\r\n  margin-right: 8px;\r\n}\r\n \r\n.file-name {\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--text-color);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n \r\n.loading-indicator {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  margin-left: 0;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  font-family: 'Inter', Arial, sans-serif;\r\n  font-size: 15px;\r\n  font-weight: bold;\r\n  line-height: 1.5;\r\n}\r\n \r\n/* Subtle fade-in and fade-out animation for the text */\r\n.loading-indicator .text {\r\n  color: gray;\r\n  animation: fadeInOut 2s infinite;\r\n}\r\n \r\n/* Subtle fade-in and fade-out animation for emojis */\r\n.loading-indicator .emoji {\r\n  margin-left: 5px;\r\n  animation: fadeInOut 2s infinite;\r\n}\r\n \r\n/* Define subtle fade-in and fade-out animation */\r\n@keyframes fadeInOut {\r\n  0% { opacity: 0.5; }\r\n  50% { opacity: 1; }\r\n  100% { opacity: 0.5; }\r\n}\r\n \r\n/* Hide scrollbar */\r\n/* .chat-window::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n.chat-window {\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n} */\r\n \r\n/* Table wrapper */\r\n.table-wrapper {\r\n  border: 1px solid var(--table-border-color);\r\n  padding: 25px 10px 10px 10px;\r\n  margin-bottom: 10px;\r\n  background: var(--table-background-color);\r\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\r\n  border-radius: 5px;\r\n  position: relative;\r\n  max-width: 90%;\r\n  width: auto;\r\n  overflow-x: auto;\r\n  display: block;\r\n}\r\n \r\n/* Table content */\r\n/* .table-content {\r\n  padding: 0px;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n  white-space: normal;\r\n} */\r\n\r\n.table-content {\r\n  padding: 0px;\r\n  white-space: normal;\r\n  overflow: unset;\r\n  max-height: none;\r\n}\r\n\r\n.table-wrapper:not(.full-screen) .table-actions {\r\n  position: absolute;\r\n  top: 4px;\r\n  right: 10px; /* 👈 push it to the right */\r\n  z-index: 10;\r\n}\r\n\r\n.markdown-content {\r\n  max-width: 100%;\r\n  overflow-wrap: break-word;\r\n  word-wrap: break-word;\r\n  display: block;\r\n}\r\n \r\n/* Full-Screen Mode */\r\n/* Full-Screen Mode - Ensure Full Table is Visible */\r\n.full-screen {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: var(--background-color);\r\n  z-index: 1000;\r\n  padding: 20px;\r\n  overflow: auto; /* Allow scrolling only when necessary */\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  max-width: 97%;\r\n  align-items: center;   /* 👈 push to left */\r\n  justify-content: center; /* 👈 push to top */\r\n  padding: 40px;              /* Optional: space from edges */\r\n}\r\n \r\n.full-screen .table-wrapper {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: 100%; /* 👈 Fill the full height of the screen */\r\n  max-height: 100%;\r\n  height: auto;\r\n}\r\n\r\n\r\n.full-screen .table-content {\r\n  width: 100%;\r\n  max-width: 100%;\r\n  height: 100%;\r\n  max-height: 100%;\r\n  padding-bottom: 40px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n \r\n/* Close Full-Screen Button */\r\n.close-fullscreen-btn {\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 40px;\r\n  background: #838282;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 12px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  border-radius: 5px;\r\n  z-index: 1100;\r\n}\r\n \r\n.close-fullscreen-btn:hover {\r\n  background: #3d3838;\r\n}\r\n \r\n/* Ensuring the icons align properly */\r\n/* Ensuring the icons align properly to the right */\r\n/* Ensuring the icons align properly to the right */\r\n/* .table-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px; \r\n  justify-content: flex-end; \r\n  width: 100%;\r\n}\r\n\r\n.full-screen .table-actions {\r\n  position: relative;\r\n  justify-content: center;\r\n  width: 100%;\r\n  right: auto;\r\n  top: auto;\r\n  margin-top: 15px;\r\n}\r\n  \r\n*/\r\n\r\n/* Normal mode - right aligned */\r\n.table-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n  width: 100%;\r\n}\r\n\r\n/* Full-screen mode - centered */\r\n.full-screen .table-actions {\r\n  display: flex;\r\n  justify-content: center;\r\n  position: static;\r\n  margin: 15px auto 20px;\r\n  width: 100%;\r\n  transform: none;\r\n}\r\n\r\n/* Table Action Icons */\r\n.download-icon, .expand-icon {\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: var(--table-accent-color);\r\n  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;\r\n}\r\n \r\n/* Ensure buttons stay in correct order */\r\n.download-icon {\r\n  order: 0; /* Appears first */\r\n}\r\n \r\n.expand-icon {\r\n  order: 1; /* Appears second */\r\n}\r\n \r\n.download-icon:hover, .expand-icon:hover {\r\n  color: #0056b3;\r\n  transform: scale(1.1);\r\n}\r\n \r\n/* Chat Window Layout */\r\n.chat-window-container {\r\n  display: flex;\r\n  height: calc(100vh - 60px); /* Below Header */\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n/* Chat Container */\r\n.chat-container {\r\n  display: flex;\r\n  height: calc(100vh - 60px);\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n \r\n/* Left Edge Detection for Hover */\r\n.hover-detect-area {\r\n  position: fixed;\r\n  left: 0;\r\n  top: 72px;\r\n  width: 10px; /* Very thin area to detect hover */\r\n  height: calc(100vh - 72px);\r\n  z-index: 1000;\r\n}\r\n \r\n/* Sidebar - Default Hidden */\r\n.sidebar {\r\n  width: 260px;\r\n  background: var(--background-color);\r\n  padding: 15px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-right: 1px solid var(--hover-background-color);\r\n  position: fixed;\r\n  left: -260px; /* Hides the sidebar */\r\n  top: 72px;\r\n  bottom: 0;\r\n  height: calc(100vh - 72px);\r\n  transition: left 0.3s ease-in-out;\r\n  overflow-y: auto;\r\n \r\n}\r\n.sidebar::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n \r\n.sidebar::-webkit-scrollbar-thumb {\r\n  background: rgba(0, 0, 0, 0.2);\r\n  border-radius: 3px;\r\n}\r\n/* Show Sidebar on Hover */\r\n.sidebar.visible {\r\n  left: 0;\r\n}\r\n \r\n/* Sidebar When Pinned */\r\n.sidebar.pinned {\r\n  left: 0;\r\n}\r\n \r\n/* Sidebar Header */\r\n.sidebar-header {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  margin-bottom: 10px;\r\n}\r\n \r\n/* Pin Button */\r\n.pin-button {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: var(--button-color);\r\n  transition: color 0.2s ease-in-out;\r\n}\r\n.pin-icon {\r\n  transition: transform 0.2s ease-in-out;\r\n}\r\n \r\n/* Highlight When Pinned */\r\n.pinned-icon {\r\n  color: #007bff !important; /* Blue color for pinned state */\r\n}\r\n \r\n/* Ensure Chat Window Doesn't Move */\r\n.chat-window {\r\n  flex-grow: 1;\r\n  padding: 20px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n \r\n \r\n.start-new-chat {\r\n  background: #4a90e2; /* Bright Blue */\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 14px; /* Reduced padding to make the button shorter */\r\n  border-radius: 6px; /* Slightly smaller radius */\r\n  font-size: 14px; /* Reduced font size */\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n \r\n/* Hover Effect */\r\n.start-new-chat:hover {\r\n  background: #0056b3; /* Darker Blue */\r\n  transform: scale(1.05);\r\n}\r\n \r\n/* Click Effect */\r\n.start-new-chat:active {\r\n  background: #004494;\r\n  transform: scale(0.98);\r\n}\r\n \r\n \r\n/* Recent Chats */\r\n.recent-chats {\r\n  margin-top: 10px;\r\n}\r\n \r\n.recent-title {\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  color: var(--text-color);\r\n  margin-bottom: 8px;\r\n}\r\n \r\n \r\n \r\n/* Chat List Styling */\r\n.chat-list {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n \r\n/* Individual Chat Item */\r\n.chat-item {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px;\r\n  background: transparent;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  color: var(--text-color);\r\n  cursor: pointer;\r\n  transition: background 0.3s ease-in-out;\r\n  position: relative;\r\n}\r\n \r\n/* Highlight Active Session */\r\n.chat-item.active-session {\r\n  background-color: rgba(135, 191, 255, 0.3); /* Light blue */\r\n  color: #007bff; /* Blue text */\r\n  font-weight: 600;\r\n  border-left: 4px solid #007bff;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n \r\n/* Hover Effect */\r\n.chat-item:hover {\r\n  background-color: rgba(135, 191, 255, 0.5);\r\n}\r\n \r\n/* Three Dots Button */\r\n.menu-button {\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: var(--text-color);\r\n  transition: color 0.2s ease-in-out;\r\n}\r\n \r\n/* Dropdown Menu (Light/Dark Mode Adaptive) */\r\n.menu-dropdown {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 100%;\r\n  background: var(--menu-background); /* Uses theme variable */\r\n  border-radius: 8px;\r\n  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);\r\n  width: 140px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 6px 0;\r\n  z-index: 100;\r\n  transition: background 0.3s ease-in-out, color 0.3s ease-in-out;\r\n}\r\n \r\n/* Dropdown Items */\r\n.menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 14px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  color: var(--menu-text-color); /* Adaptive text color */\r\n  background: transparent;\r\n  border: none;\r\n  width: 100%;\r\n  text-align: left;\r\n  transition: background 0.2s ease-in-out;\r\n}\r\n \r\n/* Hover Effect on Menu Items */\r\n.menu-item:hover {\r\n  background: var(--menu-hover-bg);\r\n}\r\n \r\n/* Delete Button Styling */\r\n.menu-item.delete {\r\n  color: #ff4d4d; /* Red for delete */\r\n}\r\n \r\n.menu-item.delete:hover {\r\n  background: rgba(255, 77, 77, 0.1);\r\n}\r\n \r\n/* Menu Icon Styling */\r\n.menu-icon {\r\n  font-size: 16px;\r\n}\r\n \r\n.disabled-session {\r\n  pointer-events: none;  /* Prevent clicks */\r\n  opacity: 0.5;         /* Dim the session visually */\r\n  cursor: not-allowed;  /* Show a blocked cursor */\r\n}\r\n \r\n.start-new-chat.disabled-session {\r\n  pointer-events: none;  /* Disable clicks */\r\n  opacity: 0.5;         /* Dim the button */\r\n  cursor: not-allowed;  /* Show blocked cursor */\r\n}\r\n \r\n/* Overlay for Popup */\r\n.overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.6);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n \r\n/* Confirmation Popup */\r\n.confirmation-popup {\r\n  background: var(--background-color);\r\n  color: var(--text-color);\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  text-align: center;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\r\n  min-width: 300px;\r\n}\r\n \r\n/* Popup Buttons */\r\n.popup-buttons {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  margin-top: 15px;\r\n}\r\n \r\n/* Cancel Button */\r\n.cancel-btn {\r\n  background: var(--button-background);\r\n  color: var(--text-color);\r\n  border: 1px solid var(--border-color);\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n \r\n.cancel-btn:hover {\r\n  background: var(--hover-background);\r\n}\r\n \r\n/* Delete Button */\r\n.delete-btn {\r\n  background: #ff4d4d;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n \r\n.delete-btn:hover {\r\n  background: #d43f3f;\r\n}\r\n \r\n \r\n/* Temporary Chat Toggle Button */\r\n.temporary-chat-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  padding: 6px 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.3s ease-in-out;\r\n}\r\n/* Bubble around the Temporary Button */\r\n.temporary-chat-bubble {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 4px 10px;\r\n  border-radius: 50px;\r\n  border: 1px solid var(--border-color);\r\n  transition: background 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\r\n  gap: 6px; /* Added space between icon and text */\r\n}\r\n \r\n.temporary-chat-bubble:hover {\r\n  background: var(--hover-background);\r\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\r\n}\r\n \r\n/* Icon Styles */\r\n.temporary-chat-icon {\r\n  font-size: 18px;\r\n  color: gray;\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n \r\n/* Active (Green) Icon */\r\n.temporary-chat-icon.active {\r\n  color: #1db954;\r\n}\r\n \r\n/* Light Mode - Black Text */\r\n[data-theme='light'] .temporary-chat-label {\r\n  color: #000;\r\n}\r\n \r\n/* Dark Mode - White Text */\r\n[data-theme='dark'] .temporary-chat-label {\r\n  color: #fff;\r\n}\r\n\r\n/* Reduced font size for Temporary Chat label */\r\n.temporary-chat-label {\r\n  font-size: 12px; /* Adjusted for smaller text */\r\n}\r\n\r\n.temporary-chat-banner {\r\n  position: fixed;\r\n  top: 75px; /* Adjust top spacing as needed */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1000;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n\r\n  background: var(--banner-background);\r\n  color: var(--banner-text);\r\n  padding: 3px 12px;\r\n  border-radius: 16px;\r\n  font-weight: 500;\r\n  font-size: 13px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\r\n\r\n  width: fit-content;\r\n  max-width: 90%;\r\n}\r\n/* Info Icon */\r\n.info-icon {\r\n  font-size: 18px;\r\n  cursor: pointer;\r\n  color: var(--info-text);\r\n  transition: color 0.3s ease-in-out;\r\n}\r\n \r\n.info-icon:hover {\r\n  color: var(--info-hover-text);\r\n}\r\n \r\n \r\n \r\n/* --- New CSS for Recents Header and Delete All Menu --- */\r\n.recents-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  position: relative; /* Needed for absolute positioning of dropdown */\r\n  margin-bottom: 8px; /* Adjust as needed */\r\n}\r\n \r\n.recents-menu-button {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n  padding: 0 5px;\r\n  line-height: 1;\r\n  color: var(--text-color);\r\n}\r\n \r\n/* Dropdown container for the Recents menu */\r\n.recents-menu-dropdown {\r\n  position: absolute;\r\n  top: 100%; /* Directly below the header */\r\n  right: 0;\r\n  background: var(--background-color); /* Use your theme variable or a fallback */\r\n  border: 1px solid var(--border-color); /* Use your theme variable */\r\n  min-width: 120px;\r\n  box-shadow: 0 2px 5px rgba(0,0,0,0.2);\r\n  z-index: 100;\r\n  padding: 5px 0;\r\n}\r\n \r\n/* Dropdown menu items */\r\n.recents-menu-dropdown .menu-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  width: 100%;\r\n  padding: 8px 12px;\r\n  font-size: 14px;\r\n  text-align: left;\r\n  color: var(--text-color);\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n \r\n.recents-menu-dropdown .menu-item:hover {\r\n  background: var(--hover-background);\r\n}\r\n \r\n/* Special styling for the Delete All item */\r\n.recents-menu-dropdown .delete-all {\r\n  color: #d9534f; /* Danger color */\r\n}\r\n\r\n\r\n.summary-popup {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  background: rgba(0, 0, 0, 0.6); /* Dark overlay */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 2000;\r\n}\r\n\r\n/* Make the content scrollable while keeping header and footer fixed */\r\n.summary-popup-content {\r\n  background: white;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 80%;\r\n  max-width: 700px;\r\n  max-height: 70vh; /* Restrict height */\r\n  display: flex;\r\n  flex-direction: column;\r\n  text-align: left; /* Align content to the left */\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n/* Scrollable text container */\r\n.summary-popup-body {\r\n  flex-grow: 1;\r\n  overflow-y: auto; /* Enable vertical scrolling */\r\n  padding: 10px;\r\n  text-align: left; /* Ensure text is left-aligned */\r\n}\r\n\r\n/* Ensure paragraphs, lists, and headings are also left-aligned */\r\n.summary-popup-body p,\r\n.summary-popup-body ul,\r\n.summary-popup-body ol,\r\n.summary-popup-body h2 {\r\n  text-align: left;\r\n}\r\n\r\n/* Restore Blue Title Color */\r\n.summary-popup-content h2 {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  margin-bottom: 10px;\r\n  color: #007bff; /* Keep titles blue */\r\n  position: sticky;\r\n  top: 0;\r\n  background: white;\r\n  padding-bottom: 10px;\r\n  z-index: 10;\r\n}\r\n\r\n/* Restore Blue for Bold Text */\r\n.summary-popup-content strong {\r\n  color: #007bff;\r\n}\r\n\r\n/* Sticky Footer (for Close button) */\r\n.summary-popup-footer {\r\n  text-align: center;\r\n  padding-top: 10px;\r\n  background: white;\r\n  position: sticky;\r\n  bottom: 0;\r\n  padding-bottom: 10px;\r\n  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1); /* Subtle shadow effect */\r\n}\r\n\r\n/* Close Button */\r\n.summary-close-btn {\r\n  background: #ff4d4d;\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 16px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  width: 100px;\r\n}\r\n\r\n.summary-close-btn:hover {\r\n  background: #d43f3f;\r\n}\r\n\r\n.spinner {\r\n  border: 4px solid rgba(0, 0, 0, 0.1);\r\n  border-left-color: #007bff;\r\n  border-radius: 50%;\r\n  width: 16px;\r\n  height: 16px;\r\n  animation: spin 1s linear infinite;\r\n  margin-left: 8px; /* Add some space between the icon and the spinner */\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n/* Position Search Icon Next to Sidebar Toggle */\r\n.search-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  margin-left: 10px;\r\n}\r\n\r\n.search-icon {\r\n  font-size: 16px;\r\n  color: #007BFF;\r\n  transition: transform 0.2s ease-in-out, color 0.3s ease-in-out;\r\n}\r\n\r\n.search-icon:hover {\r\n  color: #0056b3;\r\n  transform: scale(1.2);\r\n}\r\n\r\n.gradient-button {\r\n  background: linear-gradient(to right, #1E90FF, #32CD32); /* Adjust colors */\r\n  color: white;\r\n  border: none;\r\n  padding: 10px 20px;\r\n  border-radius: 25px;\r\n  font-size: 16px;\r\n  font-weight: bold;\r\n  cursor: pointer;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px; /* Space between text and icon */\r\n  transition: 0.3s;\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.gradient-button:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n.graph-wrapper {\r\n  position: relative;\r\n  margin-bottom: 20px;\r\n  max-width: 100%;\r\n  overflow-x: auto;\r\n  padding: 10px;\r\n  background: var(--table-background-color);\r\n  border: 1px solid var(--table-border-color);\r\n  border-radius: 8px;\r\n}\r\n\r\n.graph-expand-button {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  padding: 6px 10px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n  z-index: 10;\r\n}\r\n\r\n.graph-expand-button:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.graph-fullscreen {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 2000;\r\n  background: var(--background-color);\r\n  padding: 20px;\r\n  overflow: auto;\r\n}\r\n\r\n.graph-fullscreen .graph-expand-button {\r\n  background: #d43f3f;\r\n}\r\n\r\n.graph-fullscreen .graph-expand-button:hover {\r\n  background: #a92828;\r\n}\r\n/* Graph Plot Wrapper */\r\n/* Graph Plot Wrapper */\r\n.plot-wrapper {\r\n  position: relative;\r\n  border: 1px solid var(--table-border-color);\r\n  background: var(--table-background-color);\r\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1);\r\n  border-radius: 5px;\r\n  padding: 25px 10px 10px 10px;\r\n  margin-bottom: 20px;\r\n  overflow: hidden;\r\n  max-width: 90%;\r\n}\r\n\r\n/* Non-fullscreen mode: actions container positioning */\r\n.plot-wrapper:not(.full-screen) .plot-actions {\r\n  position: absolute;\r\n  top: 4px;\r\n  right: 5px;\r\n  z-index: 10;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n/* Fullscreen mode: wrapper styling */\r\n.full-screen.plot-wrapper {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 2000;\r\n  padding: 20px;\r\n  background: var(--background-color);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow: auto;\r\n  box-sizing: border-box;\r\n  max-width: 100%;\r\n}\r\n\r\n/* Fullscreen mode: actions container positioning */\r\n.full-screen .plot-actions {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 16px;\r\n  z-index: 10;\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n/* Plot content area */\r\n.plot-content {\r\n  max-height: 400px;\r\n  overflow: hidden;\r\n  max-width: 100%;\r\n}\r\n\r\n/* Updated Expand/Compress Button Style for Graph (matching table style) */\r\n.plot-actions button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  font-size: 18px;\r\n  color: var(--table-accent-color);\r\n  transition: color 0.2s ease-in-out, transform 0.2s ease-in-out;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.plot-actions button:hover {\r\n  color: #0056b3;\r\n  transform: scale(1.1);\r\n}\r\n\r\n.plot-actions button:focus {\r\n  outline: none;\r\n}\r\n\r\n.full-screen .plot-content {\r\n  max-height: 85vh;\r\n  overflow-y: auto;\r\n  overflow-x: auto;\r\n}\r\n\r\n.chat-window {\r\n  overflow-x: hidden !important; /* ✅ prevents horizontal scroll */\r\n}\r\n\r\n\r\n.assistant-text {\r\n  word-wrap: break-word;\r\n  overflow-wrap: break-word;\r\n  white-space: normal; /* ✅ important to prevent horizontal scroll */\r\n}\r\n\r\n\r\n.markdown-content {\r\n  word-break: break-word;\r\n  overflow-wrap: anywhere;\r\n  white-space: normal;\r\n} \r\n\r\n/* Make code blocks wrap instead of scroll */\r\n.markdown-content pre code {\r\n  display: block;\r\n  overflow-x: auto;\r\n  padding: 10px 16px;\r\n  border-radius: 8px;\r\n  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  white-space: pre-wrap;\r\n  word-break: break-word;\r\n  background-color: var(--code-bg);\r\n  color: var(--code-text);\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\r\n  transition: background 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.markdown-content pre {\r\n  margin-top: 4px;     /* 🔽 Shrink from default (usually 16px) */\r\n  margin-bottom: 4px;\r\n}\r\n\r\n/* ✅ Dark Mode Scrollbar Styling */\r\n[data-theme='dark'] .chat-window::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n[data-theme='dark'] .chat-window::-webkit-scrollbar-track {\r\n  background: #1e1e1e; /* Match your dark background */\r\n}\r\n\r\n[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb {\r\n  background-color: #555;\r\n  border-radius: 4px;\r\n  border: 2px solid #1e1e1e; /* Creates padding around the thumb */\r\n}\r\n\r\n[data-theme='dark'] .chat-window::-webkit-scrollbar-thumb:hover {\r\n  background-color: #777;\r\n}\r\n\r\n/* Firefox (scrollbar styling) */\r\n[data-theme='dark'] .chat-window {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #555 #1e1e1e;\r\n}\r\n\r\n/* ✅ Light Mode Scrollbar Styling */\r\n[data-theme='light'] .chat-window::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n[data-theme='light'] .chat-window::-webkit-scrollbar-track {\r\n  background: #f2f2f2; /* Light background */\r\n}\r\n\r\n[data-theme='light'] .chat-window::-webkit-scrollbar-thumb {\r\n  background-color: #aaa;  /* Scroll thumb */\r\n  border-radius: 4px;\r\n  border: 2px solid #f2f2f2; /* Padding around thumb */\r\n}\r\n\r\n[data-theme='light'] .chat-window::-webkit-scrollbar-thumb:hover {\r\n  background-color: #888;\r\n}\r\n\r\n/* Firefox (scrollbar styling) */\r\n[data-theme='light'] .chat-window {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: #aaa #f2f2f2;\r\n}\r\n\r\n\r\n.agent-status-message {\r\n  display: flex;\r\n  align-items: center;\r\n  font-weight: 500;\r\n  font-size: 16px;\r\n  color: #444;\r\n  gap: 6px;\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n \r\n.agent-status-message .emoji {\r\n  animation: flicker 1.2s infinite;\r\n}\r\n \r\n.agent-status-message .dots {\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n  letter-spacing: 1px;\r\n  animation: bounce 1.2s infinite;\r\n}\r\n \r\n \r\n/* Emoji flicker */\r\n@keyframes flicker {\r\n  0%, 100% { opacity: 1; }\r\n  50%      { opacity: 0.6; }\r\n}\r\n \r\n/* Optional fade-in when message appears */\r\n@keyframes fadeIn {\r\n  from { opacity: 0; transform: translateY(5px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n\r\n.dot-loader {\r\n  display: flex;\r\n  gap: 4px;\r\n  align-items: center;\r\n  height: 24px;\r\n}\r\n.dot-loader span {\r\n  width: 4px;\r\n  height: 4px;\r\n  background: #555;\r\n  border-radius: 50%;\r\n  display: inline-block;\r\n  animation: dot-blink 1s infinite alternate;\r\n}\r\n.dot-loader span:nth-child(2) { animation-delay: .2s; }\r\n.dot-loader span:nth-child(3) { animation-delay: .4s; }\r\n@keyframes dot-blink {\r\n  0%, 100% { opacity: 0.4; }\r\n  50% { opacity: 1; }\r\n}\r\n \r\n\r\n\r\n.menu-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  right: 0;\r\n  background-color: white;\r\n  box-shadow: 0 4px 8px rgba(0,0,0,0.1);\r\n  border: 1px solid #ccc;\r\n  z-index: 999;\r\n  transition: top 0.2s ease, bottom 0.2s ease;\r\n}\r\n \r\n.menu-dropdown.open-upward {\r\n  top: auto;\r\n  bottom: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
